const drawerWidth = 270;
const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    marginTop: 0,
    zIndex: 1,
    overflow: 'hidden',
    display:'flex'
  },
  appFrame: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    height: '100%',
  },
  appBar: {
    position: 'fixed',
    backgroundColor: 'rgba(52, 118, 203, 1.0)',
    paddingTop:3,
    height: 63,
    zIndex: 0,
    boxShadow: 'rgba(0, 0, 0, 0.3) 0px 1px 10px',
    marginLeft: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      height: 70,
      zIndex: 0,
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      zIndex: 2000,
      width: '100%',
      height: 70,
      zIndex: 2000,
    },
  },
  navIconHide: {
    marginLeft:-7,
    [theme.breakpoints.up('sm')]: {
      marginLeft:-7,
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  drawerPaper: {
    width: 250,
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 1px 10px',
    zDepth:0,
    width: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      marginTop: 64,
      position: 'fixed',
      height: `calc(100% - 64px)`,
    },
  },
  content: {
    backgroundColor: theme.palette.background.default,
    width: '100%',
    height:'100%',
    marginTop: 0,
    marginLeft: 0,
    paddingLeft:0,
    paddingTop:16,
    [theme.breakpoints.up('sm')]: {
      height: 'calc(100% - 64px)',
      marginTop: 0,
      marginLeft: 0,
      paddingTop: 16,
    },
    [theme.breakpoints.up('md')]: {
      paddingTop:16,
      height: 'calc(100% - 64px)',
      marginTop: 48,
      marginLeft: 270,
      width: 'calc(100% - 270px)',
    },
  },
  header: {
    width:'100%',
    height:72,
    paddingLeft:2,
    paddingReft:2,
    paddingTop:48,
    alignItems:'center',
    position:'fixed',
    fontSize: 17,
    marginLeft: 43,
    display:'none',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 43,
      display:'none',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
      display:'inline',
    },
  },
  container: {
    flexWrap: 'wrap',
    marginLeft: 10,
    paddingTop:0,
    paddingBottom:0,
    paddingLeft:0,
    paddingRight:0,
    textDecoration: 'none',
    textColor: 'rgba(255, 255, 255, 1.0)',
    textDecoration: 'none',
    borderBottom: 'none',
    boxShadow: 'none',
    alignItems: 'center',
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 16,
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 270,
    },
  },
  whiteText: {
    color: 'white',
    borderRadius:3,
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    '&:hover': {
      background: 'rgba(255, 255, 255, 0.2)',
    },
  },
  topDrawer: {
    zIndex: 3000,
  },
  menuButton: {
    zIndex: 5000,
    color: 'white',
  },
  menuList: {
    zIndex: 4000,
  },
  menuIcon: {
    color:'rgba(230, 230, 230, 1.0)',
    marginLeft: 'calc(100% - 260px)',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'calc(100% - 265px)',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 'calc(100% - 475px)',
    },
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Information/styles.js